import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/event-organizers',
    name: 'page-event-organizers',
    component: () => import('@/pages/eventOrganizers'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/event-organizer/new',
    name: 'page-event-organizer-new',
    component: () => import('@/pages/eventOrganizer'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/event-organizer/:id',
    name: 'page-event-organizer',
    component: () => import('@/pages/eventOrganizer'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
